import { render } from "./OrderOptionsModal.vue?vue&type=template&id=711cc94d&scoped=true"
import script from "./OrderOptionsModal.vue?vue&type=script&lang=js"
export * from "./OrderOptionsModal.vue?vue&type=script&lang=js"

import "./OrderOptionsModal.vue?vue&type=style&index=0&id=711cc94d&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711cc94d"]])

export default __exports__